module.exports = __webpack_public_path__ + "img/1585875504.be24ee1d.jpg";